import { useMemo } from "react";

import type { IIabCategoryItemDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";

function useIabCategoriesById(
    options: readonly IIabCategoryItemDescriptionDto[],
): Record<string, IIabCategoryItemDescriptionDto> {
    return useMemo(() => options.reduce((acum, item) => ({ ...acum, [item.id]: item }), {}), [options]);
}

export default useIabCategoriesById;
